<div class="container wrapper-width">
    <div class="filters" *ngIf="!(isTablet$ | async)">
        <form class="filter" [formGroup]="form">
            <ng-container>
                <div class="item mr-24">
                    <label class="label">Тип сделки</label>
                    <div class="control dealTypes">
                        <app-button
                            *ngFor="let dealType of dealTypes"
                            [buttonClass]="form.get('dealType').value === dealType.value ? 'small-white' : 'small-raisin-black'"
                            [text]="dealType.label"
                            [styleInline]="{ 'height': '36px', 'border': '1px solid #4D4D4D' }"
                            (buttonClick)="selectDealType(dealType.value)"
                        ></app-button>
                    </div>
                </div>
                <div class="item mr-24">
                    <label class="label">Тип недвижимости</label>
                    <div class="control">
                        <app-select
                            [control]="form.get('realtyType')"
                            [placeholder]="'Тип недвижимости'"
                            [width]="'100%'"
                            [bindValue]="'value'"
                            [bindLabel]="'label'"
                            [itemList]="objectTypes$ | async"
                            (selected)="selectRealtyType($event)">
                        </app-select>
                    </div>
                </div>
                <div class="item mr-24">
                    <label class="label">Стоимость</label>
                    <div class="control p-d-flex">
                        <input type="text" mask="separator" thousandSeparator=" "
                               class="jurta-input price-input mr-8"
                               [ngClass]="{'red-border': isValidPrice}"
                               formControlName="priceFrom"
                               (change)="priceSelect()"
                               placeholder="От">
                        <input type="text" mask="separator" thousandSeparator=" "
                               class="jurta-input price-input"
                               [ngClass]="{'red-border': isValidPrice}"
                               formControlName="priceTo"
                               placeholder="До"
                               (change)="priceSelect()"
                        >
                    </div>
                </div>
                <div class="item mr-24">
                    <label class="label">Комнатность</label>
                    <div class="control">
                        <app-button-picker [selectedOptions]="currentRoominess$ | async" (selectedEvent)="roomSelect($event)"></app-button-picker>
                    </div>
                </div>

                <div class="item">
                    <label class="label">Площадь</label>
                    <div class="control p-d-flex">
                        <input type="text" mask="separator" thousandSeparator=" "
                               class="jurta-input price-input mr-8"
                               formControlName="areaFrom"
                               (change)="areaSelect()"
                               placeholder="От">
                        <input type="text" mask="separator" thousandSeparator=" "
                               class="jurta-input price-input"
                               formControlName="areaTo"
                               (change)="areaSelect()"
                               placeholder="До">
                    </div>
                </div>
            </ng-container>

        </form>
    </div>

    <div class="buttons-block">
        <div class="left-buttons">
            <div class="select-buttons">
                <div class="select-button"
                     *ngFor="let button of cardSelectionButtons"
                     [ngClass]="{'selected': button.id === selectedMapButtonId}"
                     (click)="switchMapButton(button.id, button.tab)"
                >
                    <img [src]="button.icon" alt="icon"/>
                    <div class="label">{{ button.label }}</div>
                </div>
            </div>
            <div class="search-button ml-24" *ngIf="!(isTablet$ | async)" (click)="saveSearch()">
                <span class="mr-8"><img [src]="'assets/images/new-design-icons/search_gradient.svg'" alt="search"></span>
                <span>Сохранить поиск</span>
            </div>
        </div>
        <div class="right-buttons">
            <ng-template #countTmp>
                <div class="filters-count">{{ countFilters$ | async }}</div>
            </ng-template>
            <app-button class="mr-12"
                *ngIf="(isTablet$ | async)"
                [text]="'Фильтр'"
                [icon]="'assets/images/new-design-icons/filters-white.svg'"
                [iconDirection]="'left'"
                [rightTemplate]="countTmp"
                [buttonClass]="'small-light-gray'"
                (buttonClick)="openMoreFilters()"
            ></app-button>
            <app-button class="mr-12"
                *ngIf="!(isTablet$ | async)"
                [text]="'Ещё фильтры'"
                [icon]="'assets/images/new-design-icons/filters-white.svg'"
                [iconDirection]="'left'"
                [buttonClass]="'small-light-gray'"
                [rightTemplate]="countTmp"
                (buttonClick)="openMoreFilters()"
            ></app-button>
            <app-button
                [buttonClass]="'small-purple-gradient'"
                [text]="'Показать ' + (currentRealPropertyCount$ | async) + ' объектов'"
                [styleInline]="{ 'height': '100%' }"
                (buttonClick)="onSearch()"
            ></app-button>
        </div>
    </div>
</div>

<ng-template #showingModal>
    <app-search-modal [filter]="savedSearchFilter" (closeEvent)="showSaveSearchModal = $event"></app-search-modal>
</ng-template>
<app-panel [visible]="showSaveSearchModal" (visibleChange)="showSaveSearchModal = $event" [template]="showingModal" [header]="'Сохранить фильтры'"></app-panel>
